var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#E0F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0625 21.5H25.5V18.6875C25.5 18.2188 25.0312 17.75 24.5625 17.75H22.6875C22.1602 17.75 21.75 18.2188 21.75 18.6875V21.5H18.9375C18.4102 21.5 18 21.9688 18 22.4375V24.3125C18 24.8398 18.4102 25.25 18.9375 25.25H21.75V46.8125C21.75 47.3398 22.1602 47.75 22.6875 47.75H24.5625C25.0312 47.75 25.5 47.3398 25.5 46.8125V25.25H47.0625C47.5312 25.25 48 24.8398 48 24.3125V22.4375C48 21.9688 47.5312 21.5 47.0625 21.5ZM27.375 40.25H46.125V27.125H27.375V40.25Z",
    fill: "#3B38FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignage);
export default __webpack_public_path__ + "static/media/signage.c3fe2c51f00a2359fccd6eaaa7bd664f.svg";
export { ForwardRef as ReactComponent };